module.exports = __webpack_public_path__ + "img/avatar-drinking-wine.503f2d9b.png";